export const v50_22_base = [
  ['V50 4G天线', '电子件'],
  ['V50 P100 FPV相机', '电子件'],
  ['V50 P100 P80升级版 甩盘电机线', '电子件'],
  ['V50 P100 P80升级版负载集线板PCBA', '电子件'],
  ['V50 P100 SuperX4 Pro飞控', '电子件'],
  ['V50 P100 UPS备用电池', '电子件'],
  ['V50 P100 地形模块', '电子件'],
  ['V50 P100 料箱雷达', '电子件'],
  ['V50 P100 喷洒线', '电子件'],
  ['V50 P100 蠕动泵A', '电子件'],
  ['V50 P100 蠕动泵B', '电子件'],
  ['V50 P100 睿图', '电子件'],
  ['V50 P100 甩盘电机', '电子件'],
  ['V50 P100 摇摆雷达', '电子件'],
  ['V50 P100 药箱传感器', '电子件'],
  ['V50 P100动力电机', '电子件'],
  ['V50 P100截流阀', '电子件'],
  ['V50 P100无刷喷头', '电子件'],
  ['V50 RTK天线-L', '电子件'],
  ['V50 RTK天线-R', '电子件'],
  ['V50 WIFI数传天线', '电子件'],
  ['V50 电调', '电子件'],
  ['V50 舵机', '电子件'],
  ['V50 负载集线板睿播连接线组件', '电子件'],
  ['V50 负载集线板睿喷连接线', '电子件'],
  ['V50 负载线', '电子件'],
  ['V50 绞龙电机减速组', '电子件'],
  ['V50 中心舱集线板', '电子件'],
]
export const v50_22_advance = [
  ['V50 4G天线', '电子件'],
  ['V50 P100 FPV相机', '电子件'],
  ['V50 P100 P80升级版 甩盘电机线', '电子件'],
  ['V50 P100 P80升级版负载集线板PCBA', '电子件'],
  ['V50 P100 SuperX4 Pro飞控', '电子件'],
  ['V50 P100 UPS备用电池', '电子件'],
  ['V50 P100 地形模块', '电子件'],
  ['V50 P100 料箱雷达', '电子件'],
  ['V50 P100 喷洒线', '电子件'],
  ['V50 P100 蠕动泵A', '电子件'],
  ['V50 P100 蠕动泵B', '电子件'],
  ['V50 P100 睿图', '电子件'],
  ['V50 P100 甩盘电机', '电子件'],
  ['V50 P100 摇摆雷达', '电子件'],
  ['V50 P100 药箱传感器', '电子件'],
  ['V50 P100动力电机', '电子件'],
  ['V50 P100截流阀', '电子件'],
  ['V50 P100无刷喷头', '电子件'],
  ['V50 RTK天线-L', '电子件'],
  ['V50 RTK天线-R', '电子件'],
  ['V50 WIFI数传天线', '电子件'],
  ['V50 电调', '电子件'],
  ['V50 舵机', '电子件'],
  ['V50 负载集线板睿播连接线组件', '电子件'],
  ['V50 负载集线板睿喷连接线', '电子件'],
  ['V50 负载线', '电子件'],
  ['V50 绞龙电机减速组', '电子件'],
  ['V50 中心舱集线板', '电子件'],
  ['2.4X8铆钉', '结构件'],
  ['M2*4圆柱头内六角耐落螺丝', '结构件'],
  ['M2*8*4内六角三组合螺丝', '结构件'],
  ['M2.5*8*4.5内六角圆柱头三组合耐落螺丝', '结构件'],
  ['M3*10内六角圆柱头自攻螺丝', '结构件'],
  ['M3*14内六角自攻螺丝', '结构件'],
  ['M3*8*6内六角圆柱头三组合螺丝', '结构件'],
  ['M3*8*6内六角圆柱头三组合耐落螺丝', '结构件'],
  ['M3*8六角圆柱头三组合耐落螺丝', '结构件'],
  ['M4*10*8六角圆柱头三组合耐落螺丝', '结构件'],
  ['M4*10*8内六角圆柱头三组合螺丝', '结构件'],
  ['M4*12*8六角圆柱头三组合耐落螺丝', '结构件'],
  ['M4*16*8六角圆柱头三组合耐落螺丝', '结构件'],
  ['M4*18*8六角圆柱头三组合耐落螺丝', '结构件'],
  ['M4*8*8内六角圆柱头三组合耐落螺丝', '结构件'],
  ['M4*8平头内六角耐落螺丝', '结构件'],
  ['M4螺柱', '结构件'],
  ['M5*10*10内六角圆柱头三组合耐落螺丝', '结构件'],
  ['M5*17定制版内六角螺丝', '结构件'],
  ['M5*20*10六角圆柱头平介组合耐落螺丝', '结构件'],
  ['M5*22*10内六角圆柱头三组合螺丝', '结构件'],
  ['M5*22*10内六角圆柱头三组合耐落螺丝', '结构件'],
  ['M5*25内六角圆柱头三组合耐落螺丝', '结构件'],
  ['M5法兰防松螺母', '结构件'],
  ['M6*14*12内六角圆柱头三组合耐落螺丝', '结构件'],
  ['M6*16内六角圆柱头三组合螺丝', '结构件'],
  ['M6*40*12内六角圆柱头三组合螺丝', '结构件'],
  ['M6法兰防松螺母', '结构件'],
  ['P30/XP2020/V40/P40/P80/V50  悬挂固定挂钩', '结构件'],
  ['ST2.9*10PB内六角圆柱头自攻螺丝', '结构件'],
  ['ST2.9*16PB内六角圆柱头自攻螺丝', '结构件'],
  ['ST2.9*5PB内六角圆柱头自攻螺丝', '结构件'],
  ['ST2.9*8PB内六角圆柱头自攻螺丝', '结构件'],
  ['ST4.0x12 内六角圆柱头平尾自攻螺钉', '结构件'],
  ['ST4.2*10PA内六角圆柱头尖脚自攻螺丝', '结构件'],
  ['ST4.2*10PB内六角圆柱头自攻螺丝', '结构件'],
  ['ST4.2*14PB内六角圆柱头自攻螺丝', '结构件'],
  ['ST4.8*14PB内六角圆柱头自攻螺丝', '结构件'],
  ['ST4.8*18PB内六角圆柱头自攻螺丝', '结构件'],
  ['V40 V50 电机底座限位胶柱', '结构件'],
  ['V40 V50 电机转轴胶塞', '结构件'],
  ['V40 V50 舵臂', '结构件'],
  ['V40 V50 舵臂连杆', '结构件'],
  ['V40 V50 花键动力主轴', '结构件'],
  ['V40 V50舵机出轴弹簧', '结构件'],
  ['V40 V50舵机轴承', '结构件'],
  ['V50 P100 P80升级版  睿播甩盘电机线R型理线夹', '结构件'],
  ['V50 P100 P80升级版 睿播绞龙电机散热硅胶', '结构件'],
  ['V50 P100 P80升级版 睿播绞龙电机罩', '结构件'],
  ['V50 P100 P80升级版 睿播绞龙管抱紧卡扣', '结构件'],
  ['V50 P100 P80升级版 药箱端子卡扣件', '结构件'],
  ['V50 P100 P80升级版电池导轨胶垫', '结构件'],
  ['V50 P100 P80升级版负载集线板上盖', '结构件'],
  ['V50 P100 P80升级版负载集线板下盖', '结构件'],
  ['V50 P100 P80升级版负载集线盒防水橡胶圈', '结构件'],
  ['V50 P100 P80升级版绞龙电机减速箱硅胶O型圈', '结构件'],
  ['V50 P100 P80升级版睿播播撒器主框', '结构件'],
  ['V50 P100 P80升级版睿播绞龙电机线卡线EVA棉', '结构件'],
  ['V50 P100 P80升级版睿播绞龙对接轴', '结构件'],
  ['V50 P100 P80升级版睿播绞龙骨架油封', '结构件'],
  ['V50 P100 P80升级版睿播绞龙卡扣Ø3.5卡簧', '结构件'],
  ['V50 P100 P80升级版睿播绞龙卡扣转轴', '结构件'],
  ['V50 P100 P80升级版睿播绞龙同步齿轮-电机端', '结构件'],
  ['V50 P100 P80升级版睿播绞龙同步齿轮电机端中轴O型硅胶圈', '结构件'],
  ['V50 P100 P80升级版睿播绞龙同步齿轮-绞龙端', '结构件'],
  ['V50 P100 P80升级版睿播绞龙中轴出料口O型硅胶圈', '结构件'],
  ['V50 P100 P80升级版睿播同步齿轮盖', '结构件'],
  ['V50 P100 P80升级版睿播同步齿轮轴锁紧件', '结构件'],
  ['V50 P100 电调端子保护盖', '结构件'],
  ['V50 P100 电调端子支撑管1（长）', '结构件'],
  ['V50 P100 电调端子支撑管2（短）', '结构件'],
  ['V50 P100 电机座钢套', '结构件'],
  ['V50 P100 飞控4PIN线堵头', '结构件'],
  ['V50 P100 负载连接线接头卡件', '结构件'],
  ['V50 P100 睿播播撒器主框', '结构件'],
  ['V50 P100 睿图塑胶减震结构', '结构件'],
  ['V50 P100 睿图塑胶减震结构支架', '结构件'],
  ['V50 P100P80升级版电池导轨套件', '结构件'],
  ['V50 P100地形模块光流盖', '结构件'],
  ['V50 RTK支架', '结构件'],
  ['V50 WIFI-RTK天线卡件', '结构件'],
  ['V50 抱箍', '结构件'],
  ['V50 电池尾插后盖', '结构件'],
  ['V50 电池尾插前盖', '结构件'],
  ['V50 电调端子固定座', '结构件'],
  ['V50 电调端子固定座连接橡胶垫片', '结构件'],
  ['V50 电调输出线固定棉', '结构件'],
  ['V50 电机底座+花键动力主轴套件', '结构件'],
  ['V50 电机电调端子座固定橡胶（右）', '结构件'],
  ['V50 电机电调端子座固定橡胶（左）', '结构件'],
  ['V50 电机座限位胶垫', '结构件'],
  ['V50 舵机出轴端压盖', '结构件'],
  ['V50 舵机盖软胶垫', '结构件'],
  ['V50 负载框', '结构件'],
  ['V50 负载框胶塞', '结构件'],
  ['V50 负载框脚架管固定件', '结构件'],
  ['V50 感应支撑架', '结构件'],
  ['V50 后支撑缓冲胶塞', '结构件'],
  ['V50 机臂卡件', '结构件'],
  ['V50 机臂末端装饰盖', '结构件'],
  ['V50 机臂主轴螺栓套件', '结构件'],
  ['V50 机身支撑金属管', '结构件'],
  ['V50 机身支撑金属管固定件', '结构件'],
  ['V50 机体把手-L', '结构件'],
  ['V50 机体把手-R', '结构件'],
  ['V50 机体把手上胶塞', '结构件'],
  ['V50 机头罩', '结构件'],
  ['V50 机头罩后扣爪', '结构件'],
  ['V50 快拆搭扣', '结构件'],
  ['V50 料箱端子固定架', '结构件'],
  ['V50 料箱固定片', '结构件'],
  ['V50 料箱固定片锁紧件', '结构件'],
  ['V50 前支撑缓冲胶垫', '结构件'],
  ['V50 蠕动泵固定支架', '结构件'],
  ['V50 睿图12pin端子转接件', '结构件'],
  ['V50 水管线材护套', '结构件'],
  ['V50 线束固定卡扣', '结构件'],
  ['V50 新喷杆喷头防护卡件使用提醒标签', '结构件'],
  ['V50 新喷杆水管转接件', '结构件'],
  ['V50 药箱脚架管固定件', '结构件'],
  ['V50 一体机身主框架', '结构件'],
  ['V50 右机臂', '结构件'],
  ['V50 中心舱盖', '结构件'],
  ['V50 左机臂', '结构件'],
  ['V50防浪涌箱体限位橡胶', '结构件'],
  ['V50睿喷负载板转接件', '结构件'],
  ['V50头罩支架', '结构件'],
  ['醋酸胶布', '结构件'],
  ['防松螺母', '结构件'],
  ['有机硅胶', '结构件'],
  ['扎带', '结构件'],
]
